import { useState } from 'react';
import './candidateEducation.css';
import { Col, Row, Container } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { generateColors } from '../../../../utils/colorUtilsClientInfo';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import UniversityIcon from '../../../../assets/images/ic_phd graduate.png';

const CandidateSchoolingInfoPanel = ({ colorSeed, schoolData, title, isEditing, onFieldChange }) => {
  const [viewDetails, setViewDetails] = useState(false);
  const colours = generateColors(colorSeed);

  const handleBackPaperChange = (index, field, value) => {
    const updatedBackPapers = [...(schoolData.schoolDetails.backPapers || [])];
    updatedBackPapers[index] = {
      ...updatedBackPapers[index],
      [field]: value,
    };
    onFieldChange('schoolDetails.backPapers', updatedBackPapers);
  };

  return (
    <Container className='degreeInfoPanel'>
      <Row className="degreeInfoContainer mt-1 d-flex">
        <Col xs={2} sm={2} lg={1} className="d-flex justify-content-center">
          <span className="rounded-span" style={{ backgroundColor: colours.backgroundColor, color: colours.color }}>
            <img src={UniversityIcon} alt="University Icon" />
          </span>
        </Col>
        <Col xs={8} sm={8} lg={9} className="degreeContent">
          <Row>
            <Col xs={12}>
              <span className="title">{title}</span>
              <span className="sub-title">
                {isEditing ? (
                  <>
                    at <input
                      type="text"
                      className="form-control d-inline w-auto mx-2"
                      value={schoolData.schoolName || ''}
                      onChange={(e) => onFieldChange('schoolName', e.target.value)}
                      placeholder="School Name"
                    />
                  </>
                ) : (
                  schoolData.schoolName && <> {' '}at {schoolData.schoolName}</>
                )}
              </span>

            </Col>
          </Row>

          {(isEditing || _.get(schoolData, 'schoolDetails.startYear') || _.get(schoolData, 'schoolDetails.endYear')) && (

            <div className="d-flex align-items-center flex-wrap gap-2 mb-2">
              {isEditing ? (
                <>
                  <input
                    type="text"
                    className="form-control form-control-sm d-inline w-auto"
                    value={schoolData.schoolDetails.startYear || ''}
                    onChange={(e) => onFieldChange('schoolDetails.startYear', e.target.value)}
                    placeholder="Start Year"
                  />
                  <span>to</span>
                  <input
                    type="text"
                    className="form-control form-control-sm d-inline w-auto"
                    value={schoolData.schoolDetails.endYear || ''}
                    onChange={(e) => onFieldChange('schoolDetails.endYear', e.target.value)}
                    placeholder="End Year"
                  />
                </>
              ) : (
                <span className="sub-title1">{schoolData.schoolDetails.startYear} - {schoolData.schoolDetails.endYear}</span>
              )}
            </div>
          )}
        </Col>
        {(
          _.get(schoolData, 'schoolDetails.cgpa') ||
          (_.get(schoolData, 'schoolDetails.hasBackPapers') === 'YES' && _.get(schoolData, 'schoolDetails.backPapers.length') > 0)
        ) && (
            <Col xs={2} sm={2} lg={2} className="d-flex align-items-start justify-content-end viewDetailsContainer">
              <a
                className="viewDetailsToggle"
                onClick={(e) => {
                  e.preventDefault();
                  setViewDetails(!viewDetails);
                }}
              >
                <span className="viewMoreText-Ed">{viewDetails ? 'View Less' : 'View Details'}</span>
                <FontAwesomeIcon icon={viewDetails ? faChevronUp : faChevronDown} className="viewMoreIcon" />
              </a>
            </Col>
          )}
      </Row>

      {(viewDetails || isEditing) && (

        <Row className={`p-1 mt-1 expandedDetails pt-2 ${viewDetails && 'd-flex justify-content-center align-items-center'}`}>
          <Col lg={1}>&nbsp;</Col>
          <Col lg={9} md={8} xs={8}>
            <Row>
              <Col lg={12}>
                <p className='cgpa-container'>CGPA/Percentage:{' '}
                  {isEditing ? (
                    <input
                      type="text"
                      className="form-control d-inline w-auto"
                      value={_.get(schoolData, 'schoolDetails.cgpa') || ''}
                      onChange={(e) => onFieldChange('schoolDetails.cgpa', e.target.value)}
                    />
                  ) : (
                    <span className="cgpa">{_.get(schoolData, 'schoolDetails.cgpa')}</span>
                  )}
                </p>
              </Col>
              {schoolData?.schoolDetails?.hasBackPapers === 'YES' &&
                Array.isArray(schoolData.schoolDetails.backPapers) &&
                schoolData.schoolDetails.backPapers.length > 0 && (
                  <Col lg={12} className="mt-3">
                    <h5 className="jobDetailsTitle">Back Papers</h5>
                    <ul className="jobDetailsContent">
                      {schoolData.schoolDetails.backPapers.map((bp, idx) => (
                        <li key={`school-bp-${idx}`}>
                          {isEditing ? (
                            <>
                              <input
                                type="text"
                                className="form-control d-inline w-auto me-2"
                                value={bp.startYear || ''}
                                onChange={(e) => handleBackPaperChange(idx, 'startYear', e.target.value)}
                                placeholder="Start Year"
                              />
                              to
                              <input
                                type="text"
                                className="form-control d-inline w-auto ms-2 me-2"
                                value={bp.endYear || ''}
                                onChange={(e) => handleBackPaperChange(idx, 'endYear', e.target.value)}
                                placeholder="End Year"
                              />
                              <input
                                type="text"
                                className="form-control d-inline w-auto"
                                value={bp.reasons || ''}
                                onChange={(e) => handleBackPaperChange(idx, 'reasons', e.target.value)}
                                placeholder="Reason"
                              />
                            </>
                          ) : (
                            <>
                              <ul>
                                {bp.startYear || bp.endYear ? (
                                  <>
                                    {bp.startYear}
                                    {bp.startYear && ' - '}
                                    {bp.endYear}
                                  </>
                                ) : null}</ul>
                              {' '}<ul>
                                Reason: {bp.reasons}</ul>
                            </>
                          )}
                        </li>
                      ))}
                    </ul>
                  </Col>
                )}
            </Row>
          </Col>
          <Col lg={2}>&nbsp;</Col>
        </Row>
      )}
    </Container>
  );
};

export default CandidateSchoolingInfoPanel;